<template>
	<div>
		<h1>
			Add slider images
		</h1>

		<form class="mt-4" @submit.prevent="createSliderImages">
			<div class="form-group">
				<label for="content">
					<small class="text-muted">IMAGES</small>
				</label>
				<file-input @change="setImages" placeholder="Choose images" multiple required />
			</div>

			<button type="submit" class="btn btn-primary ld-ext-right mt-3" :disabled="loading" :class="{running: loading}">
				{{ loading ? 'Adding…' : 'Add' }}
				<div class="ld ld-ring ld-spin" />
			</button>
		</form>

		<div class="alert alert-danger mt-4" v-if="!loading && error">
			<p class="mb-0 text-center">
				{{ error }}
			</p>
		</div>
	</div>
</template>


<script>
	import store from '../../../store';
	import FileInput from '../../FileInput';
	import {getError} from '../../../helpers';
	import {mapState} from 'vuex';

	export default {
		components: {
			'file-input': FileInput,
        },

        data() {
			return {
                images: [],
                
                loading: false,
				error: '',
			};
        },
        
        methods: {
			createSliderImages() {
				this.loading = true;

				this.$store.dispatch('sliderImages/create', {
					images: this.images,
				}).then(restaurant => {
					this.$router.push({name: 'settings'});
				}).catch(e => {
					this.error = getError(e);
					this.loading = false;
				});
            },

            setImages(files) {
				this.images = files;
			}
        }
    }
</script>